import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUserClassifierTypeOptions } from '../../services/api';

export interface ClassifierTypesState {
  classifierTypesList: {
    data: any;
    status: null | 'idle' | 'loading' | 'failed';
  };
}

const initialState: ClassifierTypesState = {
  classifierTypesList: {
    data: [],
    status: null,
  },
};

export const getUserClassifierTypeOptionsAsync: any | null = createAsyncThunk(
  'classifierTypes/getUserClassifierTypeOptions',
  async ({ userId, filter }: { userId: string; filter: string }) => {
    try {
      const response = await getUserClassifierTypeOptions(userId, filter);
      return response?.data?.items ?? [];
    } catch (err: any) {
      // El back devuelve 404 cuando ni el grupo del usuario ni sus ancestros
      // tienen classifier types para ese filter. Lo tratamos como "sin opciones".
      if (err?.response?.status === 404) return [];
      throw err;
    }
  },
);

export const classifierTypesSlice = createSlice({
  name: 'classifierTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserClassifierTypeOptionsAsync.pending, (state) => {
        state.classifierTypesList.status = 'loading';
      })
      .addCase(getUserClassifierTypeOptionsAsync.fulfilled, (state, action) => {
        state.classifierTypesList.status = 'idle';
        state.classifierTypesList.data = action.payload;
      })
      .addCase(getUserClassifierTypeOptionsAsync.rejected, (state) => {
        state.classifierTypesList.status = 'failed';
      });
  },
});

export default classifierTypesSlice.reducer;
